<div class="col-lg-12 selected-pages p-2 float-left">
  @if (!hideBreadcrumbs) {
    <ul class="p-0 m-0">
      @for (crumb of crumbs$ | async; track crumb) {
        <li>
          <a [routerLink]="crumb.link" [innerHTML]="getLabel(crumb.label)"></a>
        </li>
      }
    </ul>
  }

  @if (hideBreadcrumbs) {
    <ul>
      @for (crumb of breadCrumbs; track crumb) {
        <li>
          <a [href]="openLink(crumb[1])">{{ crumb[0] }}</a>
        </li>
      }
    </ul>
  }
</div>
